import { Subtitle2 } from "src/atoms/typography";

export default (props) => <Subtitle2 {...props} />;
